import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import { useSelect } from './select';
import styles from './styles.module.scss';
import Chevron from '../../icons/chevron.svg';
export var SelectTrigger = function (_a) {
    var _b, _c, _d;
    var startIcon = _a.startIcon, className = _a.className, children = _a.children, automationId = _a.automationId;
    var _e = useSelect(), isOpen = _e.isOpen, toggleSelect = _e.toggleSelect, disabled = _e.disabled, errorMessage = _e.errorMessage, successMessage = _e.successMessage, hasValue = _e.hasValue, triggerRef = _e.triggerRef;
    var handleClick = function (e) {
        e.stopPropagation();
        e.preventDefault();
        toggleSelect();
    };
    return (_jsxs("button", { onClick: handleClick, type: "button", className: classNames(styles['trigger-button'], className, (_b = {},
            _b[styles['is-focused']] = isOpen,
            _b[styles['is-disabled']] = disabled,
            _b[styles['is-error']] = errorMessage,
            _b[styles['is-success']] = successMessage,
            _b[styles['is-selected']] = hasValue,
            _b[styles['with-start-icon']] = !!startIcon,
            _b)), ref: function (el) {
            triggerRef.current = el;
        }, "data-automation-id": "button:".concat(automationId, ":openSelect"), children: [startIcon && (_jsx("div", { className: classNames(styles['start-icon'], (_c = {}, _c[styles['is-disabled']] = disabled, _c)), children: startIcon })), children, _jsx(Chevron, { className: classNames(styles['trigger-arrow'], (_d = {
                        'u-rotate-180': !isOpen
                    },
                    _d[styles['is-disabled']] = disabled,
                    _d)) })] }));
};
